"use strict";

module.exports = {
  unique_src_ip: ['IP_src', 'inet_src_addr'],
  unique_dst_ip: ['IP_dst', 'inet_dst_addr'],
  bytes_per_src_ip: ['IP_src', 'inet_src_addr'],
  bytes_per_dst_ip: ['IP_dst', 'inet_dst_addr'],
  unique_src_route_prefix: ['src_route_prefix_len', 'inet_src_route_prefix'],
  unique_dst_route_prefix: ['dst_route_prefix_len', 'inet_dst_route_prefix'],
  unique_src_port: ['Port_src', 'l4_src_port'],
  unique_dst_port: ['Port_dst', 'l4_dst_port'],
  unique_src_as: ['AS_src', 'src_as'],
  unique_dst_as: ['AS_dst', 'dst_as'],
  unique_dst_nexthop_asn: ['dst_nexthop_asn', 'i_dst_nexthop_as_name'],
  unique_src_geo: ['Geography_src', 'src_geo'],
  unique_dst_geo: ['Geography_dst', 'dst_geo'],
  unique_src_geo_region: ['src_geo_region'],
  unique_dst_geo_region: ['dst_geo_region'],
  unique_src_geo_city: ['src_geo_city'],
  unique_dst_geo_city: ['dst_geo_city'],
  total_unique_src_ip: ['IP_src', 'inet_src_addr'],
  total_unique_dst_ip: ['IP_dst', 'inet_dst_addr'],
  total_bytes_per_src_ip: ['IP_src', 'inet_src_addr'],
  total_bytes_per_dst_ip: ['IP_dst', 'inet_dst_addr'],
  total_unique_src_route_prefix: ['src_route_prefix_len', 'inet_src_route_prefix'],
  total_unique_dst_route_prefix: ['dst_route_prefix_len', 'inet_dst_route_prefix'],
  total_unique_src_port: ['Port_src', 'l4_src_port'],
  total_unique_dst_port: ['Port_dst', 'l4_dst_port'],
  total_unique_src_as: ['AS_src', 'src_as'],
  total_unique_dst_as: ['AS_dst', 'dst_as'],
  total_unique_dst_nexthop_asn: ['dst_nexthop_asn', 'i_dst_nexthop_as_name'],
  total_unique_src_geo: ['Geography_src', 'src_geo'],
  total_unique_dst_geo: ['Geography_dst', 'dst_geo'],
  total_unique_src_geo_region: ['src_geo_region'],
  total_unique_dst_geo_region: ['dst_geo_region'],
  total_unique_src_geo_city: ['src_geo_city'],
  total_unique_dst_geo_city: ['dst_geo_city']
};